import Section from "@bmi-digital/components/section";
import { styled } from "@mui/material/styles";

export const StyledImageGalarySection = styled(Section)({
  overflow: "initial"
});
